import { Button, Card, notification, Space } from 'antd';
import { format } from 'date-fns';
import React from 'react';

import { createApiClientWithToken } from '@/service/PreRegistrationApiFactory';
import saveAsCsv from '@/service/saveAsCsv';

const DATE_FORMAT = 'yyyy/MM/dd HH:mm:ss';
const api = createApiClientWithToken();

const ExportAllRegistersAsCsv: React.FC = () => {
  const handleExportUsersAsCsv = async () => {
    const response = await api.listUsersWhoHavePlayedGacha({ hasPlayed: true }).catch((e: Error): void => {
      notification.error({
        message: 'ユーザリストの取得に失敗しました',
        description: e.message,
      });
    });
    if (!response) {
      return;
    }

    // eslint-disable-next-line no-underscore-dangle
    if (response._response.status !== 200) {
      notification.error({
        message: 'ユーザリストの取得に失敗しました',
        // eslint-disable-next-line no-underscore-dangle
        description: response._response.bodyAsText,
      });
      return;
    }

    // eslint-disable-next-line no-underscore-dangle
    const users = response._response.parsedBody;

    const headers = ['ユーザID', 'ユーザ名', 'メールアドレス', 'is_optout', 'is_optin', '最終ログイン日時'];
    const body = users.map((user) => [
      user.id ?? '',
      user.nickname ?? '',
      user.mailAddress ?? '',
      (user.isOptout ?? false).toString(),
      (user.isOptin ?? false).toString(),
      format(user.lastLoggedInAt as Date, DATE_FORMAT),
    ]);

    saveAsCsv(headers, body, `ガチャを引いたことのあるユーザリスト-${format(Date.now(), DATE_FORMAT)}`);
  };

  const handleExportGachaRegistersAsCsv = async () => {
    const response = await api.listGachaRegisters().catch((e: Error): void => {
      notification.error({
        message: 'ガチャ登録情報の取得に失敗しました',
        description: e.message,
      });
    });
    if (!response) {
      return;
    }

    // eslint-disable-next-line no-underscore-dangle
    if (response._response.status !== 200) {
      notification.error({
        message: 'ガチャ登録情報の取得に失敗しました',
        // eslint-disable-next-line no-underscore-dangle
        description: response._response.bodyAsText,
      });
      return;
    }

    // eslint-disable-next-line no-underscore-dangle
    const gachaRegisters = response._response.parsedBody;

    const headers = ['ユーザID', 'ユーザ名', 'ガチャID', 'ガチャ名', '登録OS', '登録日時'];
    const body = gachaRegisters.map((gachaRegister) => [
      gachaRegister.user?.id ?? '',
      gachaRegister.user?.nickname ?? '',
      gachaRegister.gacha?.id ?? '',
      gachaRegister.gacha?.name ?? '',
      gachaRegister.os ?? '',
      format(gachaRegister.createdAt as Date, DATE_FORMAT),
    ]);

    saveAsCsv(headers, body, `ガチャ登録情報リスト-${format(Date.now(), DATE_FORMAT)}`);
  };

  return (
    <Space direction="horizontal">
      <Card title="ユーザリスト">
        <Button type="primary" onClick={handleExportUsersAsCsv}>
          CSV として保存
        </Button>
      </Card>

      <Card title="ガチャ登録情報リスト">
        <Button type="primary" onClick={handleExportGachaRegistersAsCsv}>
          CSV として保存
        </Button>
      </Card>
    </Space>
  );
};

export default ExportAllRegistersAsCsv;
